import { useState, useEffect } from 'react';
import { loadConnectAndInitialize, StripeConnectInstance } from '@stripe/connect-js';
import { STRIPE_PUBLISHABLE_KEY } from '@modules/config';
import { fetchStripeSessionSecret } from '@modules/api';
import { useTheme } from '@mui/material';

const useStripeConnect = (connectedAccountId: string | undefined) => {
    const { palette } = useTheme();
    const [stripeConnectInstance, setStripeConnectInstance] = useState<
        StripeConnectInstance | undefined
    >();

    useEffect(() => {
        if (connectedAccountId) {
            setStripeConnectInstance(
                loadConnectAndInitialize({
                    publishableKey: STRIPE_PUBLISHABLE_KEY,
                    fetchClientSecret: fetchStripeSessionSecret,
                    appearance: {
                        overlays: 'dialog',
                        variables: {
                            colorPrimary: palette.primary.main,
                        },
                    },
                }),
            );
        }
    }, [connectedAccountId, palette.primary.main]);

    return stripeConnectInstance;
};

export default useStripeConnect;
